import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useSubscriptionExpired } from "../../hooks/useSubscriptionExpired";
import { isSubscriptionPaymentPath } from "../../utils/routes/filterDefaultRoutes";

function ClientPaymentGate() {
  const { expired } = useSubscriptionExpired();
  const location = useLocation();
  const navigate = useNavigate();
  const onPaymentPath = isSubscriptionPaymentPath(location.pathname);

  useEffect(() => {
    if (expired && !onPaymentPath) {
      navigate("/client/pay", { replace: true });
    }
  }, [expired, onPaymentPath, navigate]);

  if (expired && !onPaymentPath) {
    return null;
  }

  return <Outlet />;
}

export default ClientPaymentGate;
